module.exports = __webpack_public_path__ + "img/image (165).b7c24a79.jpg";